import React, { useState, useEffect } from "react";
import { BackgroundImage } from "../../FourthComponents";
import { aboutData } from "../../fourthUtils/constant";

const FourthAbout = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const [isHeaderFixed, setIsHeaderFixed] = useState(false);
    useEffect(() => {
        let lastScrollTop = 0;
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 40) {
                setIsHeaderFixed(true);
            } else {
                setIsHeaderFixed(false);
            }
            lastScrollTop = scrollTop;
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <div className={isHeaderFixed ? "frth-design-screens-main" : ""}>
            <BackgroundImage heading={selectedLanguage?.txt_cairo_capital_clinics} screenName={selectedLanguage?.txt_about_us} mainClass={'frth-design-about-banner'} />
            <div className="frth-des-about-main">
                {
                    aboutData?.map((v, i) => {
                        return (
                            <div>
                                <h5>
                                    {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                </h5>
                                <p>
                                    {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                </p>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default FourthAbout